<template>
  <div>
    <div class="md-layout" v-if="loading">
      <div class="md-layout-item md-size-100">
        <md-progress-spinner :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>
        {{msg_status}} ..
      </div>
    </div>
    <div class="md-layout" v-if="qtdes != null">
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
        <a style="cursor:pointer" v-on:click="redirect('/operacional/auditoria?status=0')">
          <stats-card header-color="blue">
            <template slot="header">
              <div class="card-icon">
                <i class="fa fa-clipboard-list"></i>
              </div>
              <p class="category">Auditorias Submetidas</p>
              <h3 class="title">
                <animated-number :value="qtdes.auditoria_submetidas"></animated-number>
              </h3>
            </template>

            <template slot="footer">
              <div class="stats" v-if="false">Submetidas</div>
            </template>
          </stats-card>
        </a>
      </div>

      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
        <a style="cursor:pointer" v-on:click="redirect('/operacional/auditoria?status=1')">
          <stats-card header-color="blue">
            <template slot="header">
              <div class="card-icon">
                <i class="fa fa-tasks"></i>
              </div>
              <p class="category">Auditorias Publicadas</p>
              <h3 class="title">
                <animated-number :value="qtdes.auditorias_publicadas"></animated-number>
              </h3>
            </template>

            <template slot="footer">
              <div class="stats" v-if="false">Publicadas</div>
            </template>
          </stats-card>
        </a>
      </div>

      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
        <a style="cursor:pointer" v-on:click="redirect('/operacional/visita')">
          <stats-card header-color="blue">
            <template slot="header">
              <div class="card-icon">
                <i class="fa fa-file"></i>
              </div>
              <p class="category">Diagnóstico e plano de ação</p>
              <h3 class="title">
                <animated-number :value="qtdes.visita_tecnica"></animated-number>
              </h3>
            </template>

            <template slot="footer" v-if="false">
              <div class="stats">Submetidas</div>
            </template>
          </stats-card>
        </a>
      </div>

      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
        <a style="cursor:pointer" v-on:click="redirect('/operacional/validade')">
          <stats-card header-color="blue">
            <template slot="header">
              <div class="card-icon">
                <i class="fa fa-calendar"></i>
              </div>
              <p class="category">Laudos</p>
              <h3 class="title">
                <animated-number :value="qtdes.inspecao_produtos"></animated-number>
              </h3>
            </template>

            <template slot="footer" v-if="false">
              <div class="stats">Publicadas</div>
            </template>
          </stats-card>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import AnimatedNumber from "@/components/AnimatedNumber";
import StatsCard from "@/components/Cards/StatsCard";
import service from "../../../services/DashBoardService.js"; // getIndexAdmin

export default {
  components: {
    StatsCard,
    AnimatedNumber
  },
  data: () => ({
    loading: false,
    msg_status: "Carregando..",
    result: {},
    show_modal: false,
    form: null,
    qtdes: null
  }),
  mounted() {
    var self = this;
    self.loading = true;
    service.getIndexAdmin().then(function(response) {
      console.log("response?", response);
      self.qtdes = response.data.data.qtdes;
      self.loading = false;
    });
  },
  methods: {
    closeModal() {
      this.show_modal = false;
    },
    visualizar(item) {
      this.form = item;
      this.show_modal = true;
    },
    redirect(path) {
      //{ name: item.name, path: item.path , icon: item.icon }
      //"/area/auditoria"
      this.$router.push({ path: path });
    }
  }
};
</script>